import { Mixin } from "../../../ChronoGraph/class/BetterMixin.js";
import { SchedulerCoreEvent } from "../model/scheduler_core/SchedulerCoreEvent.js";
import { CorePartOfProjectStoreMixin } from "./mixin/CorePartOfProjectStoreMixin.js";
import { AbstractEventStoreMixin } from "./AbstractEventStoreMixin.js";
/**
 * A store mixin class, that represent collection of all events in the [[SchedulerCoreProjectMixin|project]].
 */
export class CoreEventStoreMixin extends Mixin([AbstractEventStoreMixin, CorePartOfProjectStoreMixin], (base) => {
    const superProto = base.prototype;
    class CoreEventStoreMixin extends base {
        joinProject() {
            this.assignmentStore?.linkAssignments(this, 'event');
        }
        afterLoadData() {
            this.afterEventRemoval();
            this.assignmentStore?.linkAssignments(this, 'event');
        }
    }
    CoreEventStoreMixin.configurable = {
        modelClass: SchedulerCoreEvent
    };
    return CoreEventStoreMixin;
}) {
}
